// TODO - remove this alias
import HelpIcon from "./helpicon/HelpIcon";
export default HelpIcon;